import * as React from "react"
const SvgComponent = ({
  fill = "currentColor",
  strokeWidth = 0.5,
  strokeColor = "#000",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="_\u30EC\u30A4\u30E4\u30FC_2"
    data-name="\u30EC\u30A4\u30E4\u30FC 2"
    viewBox="0 0 51 32.06"
  >
    <g id="day_mode" data-name="day mode">
      <path
        d="m.5 3.3 50 1.53v22.76l-50 1.53V3.3z"
        style={{
          fill: fill,
          stroke: strokeColor,
          strokeWidth: strokeWidth,
          strokeMiterlimit: 10,
        }}
      />
      <path d="M5.29 30.56V1.5M11.64 30.56V1.5" className="cls-1" />
    </g>
  </svg>
)
export default SvgComponent
